import React from 'react';
import RemoveFileBtn from '../RemoveFileBtn';
import styles from './index.module.scss';

const Image = ({ src, name, removeFile, index, onClick }) => {
  return (
    <div className={styles.fileWrapper}>
      <img
        src={src}
        alt={name}
        className={styles.file}
        onClick={() => onClick(index)}
      />
      {typeof removeFile === 'function' && (
        <RemoveFileBtn
          className={styles.deleteFile}
          onClick={() => removeFile(index)}
        />
      )}
    </div>
  );
};

export default Image;
